import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { spawn } from '../../utils/translations';
import {
  GitlabClient,
  GitlabGroupWebhookInstallRequest,
} from '../httpClients/GitlabClient';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

export const useInstallGitlabWebhooksByGroupsMutation = () => {
  const spawnToasts = spawn('toasts.gitlab.install-webhooks');

  return useMutation({
    mutationKey: [MUTATION_KEYS.INSTALL_GITLAB_WEBHOOKS_BY_GROUPS],
    mutationFn: (request: GitlabGroupWebhookInstallRequest) =>
      GitlabClient.installWebhooksByGroups(request),
    onError: (err: any) => {
      const errorFromServer = getErrorToastContent(err, spawnToasts('error'));

      toast.error(errorFromServer);
    },
  });
};
